import { YStack, Text } from 'tamagui'
import type { CascadeSlide as CascadeSlideType } from '../../../content/decks/types'
import { SlideContainer, SlideInner, getAccentColor, getAccentGlow, parseLinkedText } from './shared'

export function CascadeSlide({ slide }: { slide: CascadeSlideType }) {
  const accentColor = getAccentColor(slide.accent)
  return (
    <SlideContainer>
      <SlideInner style={{ padding: 'clamp(32px, 6vw, 80px)' }}>
        <Text
          fontFamily="$heading"
          fontWeight="700"
          color="$textPrimary"
          style={{ fontSize: 'clamp(24px, 3.5vw, 44px)', lineHeight: '1.2em' }}
        >
          {slide.headline}
        </Text>
        <YStack gap="$3" marginTop="$6">
          {slide.lines.map((line, i) => (
            <Text
              key={i}
              fontFamily="$mono"
              color="$textSecondary"
              style={{
                fontSize: 'clamp(14px, 2vw, 26px)',
                paddingLeft: `${i * 20}px`,
                opacity: 0.6 + (i / slide.lines.length) * 0.4,
              }}
            >
              {parseLinkedText(line)}
            </Text>
          ))}
        </YStack>
        {slide.punchline && (
          <Text
            fontFamily="$heading"
            fontWeight="600"
            color={accentColor}
            marginTop="$8"
            style={{
              fontSize: 'clamp(18px, 2.5vw, 32px)',
              textShadow: getAccentGlow(slide.accent),
            }}
          >
            {slide.punchline}
          </Text>
        )}
      </SlideInner>
    </SlideContainer>
  )
}
